<template>
    <div class="instagram-form">
        <h1 v-if="step !== 4">{{ data.name.charAt(0).toUpperCase() + data.name.slice(1) }}<span class="purple-text">.</span></h1>

        <Loader v-if="loading">
            Sprawdzam...
        </Loader>

        <div class="step-1" v-if="step === 1 && !loading">

            <div class="white-box-wrap">
                <span class="white-box"><img :src="'/img/logos/' + data.icon_color"/></span>
            </div>

            <div class="enter-nick">
                <div class="form-group">
                    <input-group v-model="form.url" :val="form.url" placeholder="Wpisz swój nick na instagramie" class="big"
                                 :valid="!showNickError">
                        <template v-slot:errorMessage>{{ wrongNickError ? 'Podany profil nie istnieje' : 'Podaj swój nick' }}</template>
                    </input-group>
                </div>
                <div class="text-center">
                    <button v-on:click="secondStep" class="submit-purple-button">Dalej</button>
                </div>
            </div>
        </div>
        <div class="step-2" v-if="step === 2 && !loading">

            <div class="white-box-wrap">
                <span class="white-box"><img :src="'/img/logos/' + data.icon_color"/></span>
            </div>

            <h3>Musimy sprawdzić</h3>
            <p class="subtitle">czy konto należy do Ciebie.</p>

            <div class="instructions">
                <p><strong>1.</strong> Skopiuj hasztag weryfikacyjny</p>
                <p><strong>2.</strong> Wklej go w opisie Twojego ostatniego posta na Instagramie</p>
                <p><strong>3.</strong> Dopiero wtedy kliknij "sprawdź konto"</p>
            </div>

            <div class="hashtag" v-on:click="copyTextToClipboard(hash)">
                <img src="../../../assets/copy_icon.png"/>
                <p>{{hash}}</p>
            </div>

            <div class="navigation step-navigation">
                <button v-on:click="firstStep" class="submit-transparent-button">Zmień nick</button>
                <button v-on:click="checkAccount" class="submit-purple-button">Sprawdź konto</button>
            </div>

        </div>

        <div class="step-3" v-if="step === 3 && !loading">

            <div class="white-box-wrap">
                <span class="white-box"><img :src="'/img/logos/' + data.icon_color"/></span>
            </div>

            <h3>Poszło gładko</h3>
            <p class="subtitle">Twoje konto na Instagramie zostało dodane.</p>


            <h4>Zasady współpracy</h4>

            <div class="barter-buttons">
                <icon-text-checkbox :nolabel="true" v-model="form.isBarter" :value="form.isBarter">
                    <template v-slot:image>
                        <img src="../../../assets/barter_icon.png" />
                    </template>
                </icon-text-checkbox>

                <icon-text-input-checkbox :nolabel="true" v-model="form.isPaid" :value="form.isPaid" :value-income="form.income" v-on:income="incomeChange">
                    <template v-slot:image>
                        <img src="../../../assets/cash_icon.png" />
                    </template>
                </icon-text-input-checkbox>
            </div>

            <form-error :show="!errors.barter" className="barter-error">
                <template v-slot:errorMessage>
                    Wybierz zasadę współpracy
                </template>
            </form-error>

            <form-error :show="!errors.income" className="income-error">
                <template v-slot:errorMessage>
                    Uzupełnij wynagrodzenie
                </template>
            </form-error>

            <div class="income-form">
                <span v-if="form.isBarter && !form.isPaid" class="income-label">Współpraca barterowa</span>
                <span v-if="!form.isBarter && form.isPaid" class="income-label">Tylko płatne wpisy</span>
                <span v-if="form.isBarter && form.isPaid" class="income-label">Współpraca barterowa lub płatna</span>
            </div>

            <div class="navigation">
                <button v-on:click="submit" class="submit-purple-button">Dalej</button>
            </div>

        </div>

        <div class="step-4" v-if="step === 4 && !loading">
            <div class="header">
                <h1>Mamy problem<span class="purple-text">.</span></h1>
                <p>Twój unikalny hasztag weryfikacyjny<br/>nie został wykryty na profilu.</p>
            </div>

            <div class="icon">
                <img src="../../../assets/problem_icon.png" />
            </div>

            <div class="info">
                <h3>Upewnij się, że:</h3>
                <p><strong>dodałeś hashtag w opisie posta,&nbsp;</strong>a nie w komentarzu</p>
                <p><strong>Twój profil jest publiczny,&nbsp;</strong>a nie widoczny tylko dla obserwujących</p>
                <p><strong>podane konto należy do Ciebie&nbsp;</strong>jeśli nie, wpisz prawidłowy nick</p>
            </div>

            <div class="hashtag" v-on:click="copyTextToClipboard(hash)">
                <img src="../../../assets/copy_icon.png"/>
                <p>{{hash}}</p>
            </div>

            <div class="navigation step-navigation">
                <button v-on:click="firstStep" class="submit-transparent-button">Zmień nick</button>
                <button v-on:click="checkAccount" class="submit-purple-button">Sprawdź konto</button>
            </div>
        </div>

        <div class="step-4" v-if="step === 5 && !loading">
            <div class="header">
                <h1>Ups<span class="purple-text">!</span></h1>
                <p>Masz za mało obserwujących.</p>
            </div>

            <div class="icon">
                <img src="../../../assets/problem_icon.png" />
            </div>

            <div class="info">
                <h3></h3>
                <p>Rozwijaj swój profil i wróć do nas gdy zdobędziesz ponad 1000 obserwujących na Instagramie.</p>
                <p><strong>Do zobaczenia!</strong></p>
            </div>

            <div class="navigation step-navigation">
                <button v-on:click="firstStep" class="submit-transparent-button">Zmień nick</button>
            </div>
        </div>

        <floating-navigation v-if="!loading">
            <button v-on:click="$emit('go-back')" type="button" class="go-back-button"></button>
            <button v-if="step !== 3 && !instagramOnly" v-on:click="$emit('cancel-step')" class="clear-right-button">pomiń {{data.name}}</button>
        </floating-navigation>
    </div>
</template>

<script>
    import InputGroup from "../elements/InputGroup";
    import Loader from "../../Loader";
    import Router from "../../../routing";
    import IconTextCheckbox from "../elements/IconTextCheckbox";
    import IconTextInputCheckbox from "../elements/IconTextInputCheckbox";
    import FormError from "../elements/FormError";
    import FloatingNavigation from "../elements/floatingNavigation";
    import { instagramOnly } from '../../../variables';
    import Instagram from '../../../Instagram';


    export default {
        name: "SocialInstagram",
        components: {FloatingNavigation, FormError, IconTextInputCheckbox, IconTextCheckbox, Loader, InputGroup},
        props: ["data", "value", "index", "user"],
        mounted() {
            this.hash = this.user.instagramVerifyToken;
            this.form = this.value;

            this.instagram = new Instagram();
        },
        async updated() {
            await this.$nextTick();
            var resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent .initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
        },
        data() {
            return {
                nick: '',
                showNickError: false,
                wrongNickError: false,
                hash: '',
                instagram: null,
                instagramOnly: instagramOnly,
                step: 1,
                loading: false,
                form: {
                    valid: true,
                    url: "",
                    score: "",
                    isBarter: false,
                    isPaid: false,
                    income: ""
                },
                errors: {
                    barter: true,
                    income: true
                }
            };
        },
        watch: {
            form: {
                handler(val) {
                    this.resetErrors();
                    this.$emit('input', val);
                },
                deep: true
            },

            value: {
                handler(val) {
                    this.form = val;
                },
                deep: true
            },
            index: function () {
                this.form = this.value;
                this.resetErrors();
            }
        },
        methods: {
            firstStep: function () {
                this.step = 1;
            },
            secondStep: function () {
                this.showNickError = false;
                this.wrongNickError = false;

                if (this.form.url < 2) {
                    this.showNickError = true;
                    return;
                }

                this.loading = true;

                if(this.form.url === 'makaronIParowki') {
                    this.step = 2;
                }

                this.instagram.scrapeAccount(this.form.url, (result) => {

                    if(result) {

                        if(result.followers <= 1000) {
                            this.step = 5;
                        }
                        else {
                            this.step = 2;
                        }

                    }
                    else {
                        this.showNickError = true;
                        this.wrongNickError = true;
                    }

                    this.loading = false;

                });

            },
            checkAccount: function () {
                this.loading = true;

                if(this.form.url === 'makaronIParowki') {
                    this.form.score = 20;
                    this.step = 3;
                    this.loading = false;

                    return;
                }

                this.instagram.scrapeAndVerifyAccount(this.form.url, this.hash, (result) => {

                    if(result) {
                        this.step = 3;
                        this.form.score = result.followers;
                    }
                    else {
                        this.step = 4;
                    }

                    this.loading = false;
                });

            },
            submit: function() {
                this.resetErrors();

                this.errors.barter = (this.form.isPaid || this.form.isBarter);
                this.errors.income = (!this.form.isPaid || this.form.income && ((this.form.isPaid && (this.form.income.length))));

                if(!this.isValid()) return;

                this.form.valid = true;

                this.$emit('next-step');
            },
            isValid() {
                if(!this.errors.barter) return false;
                if(!this.errors.income) return false;

                return true;
            },
            incomeChange: function(income) {
                this.form.income = income;
            },
            resetErrors() {
                this.errors = {
                    barter: true,
                    income: true,
                };
            },
            fallbackCopyTextToClipboard: function (text) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    this.$notify({
                        group: 'form',
                        type: 'success',
                        title: 'Skopiowano do schowka!'
                    });
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            },
            copyTextToClipboard: function (text) {
                if (!navigator.clipboard) {
                    this.fallbackCopyTextToClipboard(text);
                    return;
                }
                navigator.clipboard.writeText(text).then(function () {
                    this.$notify({
                        group: 'form',
                        type: 'success',
                        title: 'Skopiowano do schowka!'
                    });
                }.bind(this), function (err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
